export default "__VITE_ASSET__Cp2EC7qW__"